import { BookOpenIcon, FlameIcon, StarIcon } from "lucide-react";

import { CountUpValue } from "@/components/CountUpValue";
import { useStudySummaryQuery } from "@/hooks/queries";

export function QuickStats() {
  const { data } = useStudySummaryQuery();

  const stats = [
    { icon: FlameIcon, label: "완료한 테스트", value: data?.completedTests ?? 0, suffix: "개", color: "text-red-500" },
    {
      icon: StarIcon,
      label: "평균 점수",
      value: data?.avgScore ?? 0,
      suffix: "점",
      color: "text-yellow-500",
    },
    {
      icon: BookOpenIcon,
      label: "학습한 단어",
      value: data?.wordsLearned ?? 0,
      suffix: "개",
      formatValue: (value: number) => value.toLocaleString(),
      color: "text-emerald-500",
    },
  ];

  return (
    <div className="grid grid-cols-3 gap-3">
      {stats.map(({ icon: Icon, label, value, suffix, color, formatValue }) => (
        <div key={label} className="rounded-xl bg-card p-4 flex flex-col items-center gap-1.5">
          <Icon className={`size-5 ${color}`} />

          <CountUpValue
            key={`${label}-${value}`}
            targetValue={value}
            suffix={suffix}
            formatValue={formatValue}
            className="text-base font-bold text-foreground"
          />
          <p className="text-[11px] text-muted-foreground text-center leading-tight">{label}</p>
        </div>
      ))}
    </div>
  );
}
